import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Plus, Image as ImageIcon } from 'lucide-react';
import { useShopCart } from '../../../context/ShopCartContext';
import { toast } from 'sonner';

const formatRWF = (n) => new Intl.NumberFormat('en-RW', { maximumFractionDigits: 0 }).format(n);

export const ProductCard = ({ product }) => {
  const { addItem } = useShopCart();
  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!product.in_stock) return;
    addItem(product, 1);
    toast.success(`Added ${product.name} to cart`);
  };

  return (
    <Link
      to={`/shop/product/${product.id}`}
      className="group rounded-xl border border-border bg-card overflow-hidden hover:shadow-md transition"
      data-testid={`product-card-${product.id}`}
    >
      <div className="aspect-square bg-gradient-to-br from-muted to-muted/40 flex items-center justify-center relative overflow-hidden">
        {product.image_url ? (
          <img src={product.image_url} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition" />
        ) : (
          <ImageIcon className="w-12 h-12 text-muted-foreground/50" />
        )}
        {product.discount_percent > 0 && (
          <span className="absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-semibold">-{product.discount_percent}%</span>
        )}
        {!product.in_stock && (
          <span className="absolute top-2 right-2 bg-muted text-foreground text-xs px-2 py-0.5 rounded-full font-medium">Out of stock</span>
        )}
      </div>
      <div className="p-3">
        <div className="text-xs text-muted-foreground capitalize">{product.category}</div>
        <div className="font-medium text-sm line-clamp-1">{product.name}</div>
        <div className="flex items-end justify-between mt-2">
          <div>
            {product.discount_percent > 0 && (
              <div className="text-xs text-muted-foreground line-through">RWF {formatRWF(product.price)}</div>
            )}
            <div className="font-semibold text-primary">RWF {formatRWF(product.final_price)} <span className="text-xs font-normal text-muted-foreground">/ {product.unit}</span></div>
          </div>
          <Button
            size="sm"
            onClick={handleAdd}
            disabled={!product.in_stock}
            className="rounded-full h-8 w-8 p-0"
            data-testid={`add-to-cart-${product.id}`}
          >
            <Plus className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </Link>
  );
};
